/* eslint-disable prefer-template */
import React from 'react';
import { GridProps } from './GridContainer';

type GridItemColType = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

type GridItemType = 'auto' | null | GridItemColType;

export interface GridItemProps extends GridProps {
  children: React.ReactNode;
  xs?: GridItemType;
  s?: GridItemType;
  m?: GridItemType;
  ml?: GridItemType;
  l?: GridItemType;
  xl?: GridItemType;
  colStartXs?: GridItemColType;
  colEndXs?: GridItemColType;
  colStartS?: GridItemColType;
  colEndS?: GridItemColType;
  colStartM?: GridItemColType;
  colEndM?: GridItemColType;
  colStartMl?: GridItemColType;
  colEndMl?: GridItemColType;
  colStartL?: GridItemColType;
  colEndL?: GridItemColType;
  colStartXl?: GridItemColType;
  colEndXl?: GridItemColType;
}

function getColEndString(xs: GridItemColType): string {
  switch (xs) {
    case 1:
      return 'col-end-1';
    case 2:
      return 'col-end-2';
    case 3:
      return 'col-end-3';
    case 4:
      return 'col-end-4';
    case 5:
      return 'col-end-5';
    case 6:
      return 'col-end-6';
    case 7:
      return 'col-end-7';
    case 8:
      return 'col-end-8';
    case 9:
      return 'col-end-9';
    case 10:
      return 'col-end-10';
    case 11:
      return 'col-end-11';
    case 12:
      return 'col-end-12';
    default:
      return 'col-end-0';
  }
}
function getColEndStringS(s: GridItemColType): string {
  switch (s) {
    case 1:
      return 's:col-end-1';
    case 2:
      return 's:col-end-2';
    case 3:
      return 's:col-end-3';
    case 4:
      return 's:col-end-4';
    case 5:
      return 's:col-end-5';
    case 6:
      return 's:col-end-6';
    case 7:
      return 's:col-end-7';
    case 8:
      return 's:col-end-8';
    case 9:
      return 's:col-end-9';
    case 10:
      return 's:col-end-10';
    case 11:
      return 's:col-end-11';
    case 12:
      return 's:col-end-12';
    default:
      return 's:col-end-0';
  }
}
function getColEndStringM(m: GridItemColType): string {
  switch (m) {
    case 1:
      return 'm:col-end-1';
    case 2:
      return 'm:col-end-2';
    case 3:
      return 'm:col-end-3';
    case 4:
      return 'm:col-end-4';
    case 5:
      return 'm:col-end-5';
    case 6:
      return 'm:col-end-6';
    case 7:
      return 'm:col-end-7';
    case 8:
      return 'm:col-end-8';
    case 9:
      return 'm:col-end-9';
    case 10:
      return 'm:col-end-10';
    case 11:
      return 'm:col-end-11';
    case 12:
      return 'm:col-end-12';
    default:
      return 'm:col-end-0';
  }
}
function getColEndStringMl(ml: GridItemColType): string {
  switch (ml) {
    case 1:
      return 'ml:col-end-1';
    case 2:
      return 'ml:col-end-2';
    case 3:
      return 'ml:col-end-3';
    case 4:
      return 'ml:col-end-4';
    case 5:
      return 'ml:col-end-5';
    case 6:
      return 'ml:col-end-6';
    case 7:
      return 'ml:col-end-7';
    case 8:
      return 'ml:col-end-8';
    case 9:
      return 'ml:col-end-9';
    case 10:
      return 'ml:col-end-10';
    case 11:
      return 'ml:col-end-11';
    case 12:
      return 'ml:col-end-12';
    default:
      return 'ml:col-end-0';
  }
}
function getColEndStringL(l: GridItemColType): string {
  switch (l) {
    case 1:
      return 'l:col-end-1';
    case 2:
      return 'l:col-end-2';
    case 3:
      return 'l:col-end-3';
    case 4:
      return 'l:col-end-4';
    case 5:
      return 'l:col-end-5';
    case 6:
      return 'l:col-end-6';
    case 7:
      return 'l:col-end-7';
    case 8:
      return 'l:col-end-8';
    case 9:
      return 'l:col-end-9';
    case 10:
      return 'l:col-end-10';
    case 11:
      return 'l:col-end-11';
    case 12:
      return 'l:col-end-12';
    default:
      return 'l:col-end-0';
  }
}
function getColEndStringXl(xl: GridItemColType): string {
  switch (xl) {
    case 1:
      return 'xl:col-end-1';
    case 2:
      return 'xl:col-end-2';
    case 3:
      return 'xl:col-end-3';
    case 4:
      return 'xl:col-end-4';
    case 5:
      return 'xl:col-end-5';
    case 6:
      return 'xl:col-end-6';
    case 7:
      return 'xl:col-end-7';
    case 8:
      return 'xl:col-end-8';
    case 9:
      return 'xl:col-end-9';
    case 10:
      return 'xl:col-end-10';
    case 11:
      return 'xl:col-end-11';
    case 12:
      return 'xl:col-end-12';
    default:
      return 'xl:col-end-0';
  }
}
function getColStartString(xs: GridItemColType): string {
  switch (xs) {
    case 1:
      return 'col-start-1';
    case 2:
      return 'col-start-2';
    case 3:
      return 'col-start-3';
    case 4:
      return 'col-start-4';
    case 5:
      return 'col-start-5';
    case 6:
      return 'col-start-6';
    case 7:
      return 'col-start-7';
    case 8:
      return 'col-start-8';
    case 9:
      return 'col-start-9';
    case 10:
      return 'col-start-10';
    case 11:
      return 'col-start-11';
    case 12:
      return 'col-start-12';
    default:
      return 'col-start-0';
  }
}
function getColStartStringS(s: GridItemColType): string {
  switch (s) {
    case 1:
      return 's:col-start-1';
    case 2:
      return 's:col-start-2';
    case 3:
      return 's:col-start-3';
    case 4:
      return 's:col-start-4';
    case 5:
      return 's:col-start-5';
    case 6:
      return 's:col-start-6';
    case 7:
      return 's:col-start-7';
    case 8:
      return 's:col-start-8';
    case 9:
      return 's:col-start-9';
    case 10:
      return 's:col-start-10';
    case 11:
      return 's:col-start-11';
    case 12:
      return 's:col-start-12';
    default:
      return 's:col-start-0';
  }
}
function getColStartStringM(m: GridItemColType): string {
  switch (m) {
    case 1:
      return 'm:col-start-1';
    case 2:
      return 'm:col-start-2';
    case 3:
      return 'm:col-start-3';
    case 4:
      return 'm:col-start-4';
    case 5:
      return 'm:col-start-5';
    case 6:
      return 'm:col-start-6';
    case 7:
      return 'm:col-start-7';
    case 8:
      return 'm:col-start-8';
    case 9:
      return 'm:col-start-9';
    case 10:
      return 'm:col-start-10';
    case 11:
      return 'm:col-start-11';
    case 12:
      return 'm:col-start-12';
    default:
      return 'm:col-start-0';
  }
}
function getColStartStringMl(ml: GridItemColType): string {
  switch (ml) {
    case 1:
      return 'ml:col-start-1';
    case 2:
      return 'ml:col-start-2';
    case 3:
      return 'ml:col-start-3';
    case 4:
      return 'ml:col-start-4';
    case 5:
      return 'ml:col-start-5';
    case 6:
      return 'ml:col-start-6';
    case 7:
      return 'ml:col-start-7';
    case 8:
      return 'ml:col-start-8';
    case 9:
      return 'ml:col-start-9';
    case 10:
      return 'ml:col-start-10';
    case 11:
      return 'ml:col-start-11';
    case 12:
      return 'ml:col-start-12';
    default:
      return 'ml:col-start-0';
  }
}
function getColStartStringL(l: GridItemColType): string {
  switch (l) {
    case 1:
      return 'l:col-start-1';
    case 2:
      return 'l:col-start-2';
    case 3:
      return 'l:col-start-3';
    case 4:
      return 'l:col-start-4';
    case 5:
      return 'l:col-start-5';
    case 6:
      return 'l:col-start-6';
    case 7:
      return 'l:col-start-7';
    case 8:
      return 'l:col-start-8';
    case 9:
      return 'l:col-start-9';
    case 10:
      return 'l:col-start-10';
    case 11:
      return 'l:col-start-11';
    case 12:
      return 'l:col-start-12';
    default:
      return 'l:col-start-0';
  }
}
function getColStartStringXl(xl: GridItemColType): string {
  switch (xl) {
    case 1:
      return 'xl:col-start-1';
    case 2:
      return 'xl:col-start-2';
    case 3:
      return 'xl:col-start-3';
    case 4:
      return 'xl:col-start-4';
    case 5:
      return 'xl:col-start-5';
    case 6:
      return 'xl:col-start-6';
    case 7:
      return 'xl:col-start-7';
    case 8:
      return 'xl:col-start-8';
    case 9:
      return 'xl:col-start-9';
    case 10:
      return 'xl:col-start-10';
    case 11:
      return 'xl:col-start-11';
    case 12:
      return 'xl:col-start-12';
    default:
      return 'xl:col-start-0';
  }
}

function getColSpanString(xs: GridItemType): string {
  switch (xs) {
    case 1:
      return 'col-span-1';
    case 2:
      return 'col-span-2';
    case 3:
      return 'col-span-3';
    case 4:
      return 'col-span-4';
    case 5:
      return 'col-span-5';
    case 6:
      return 'col-span-6';
    case 7:
      return 'col-span-7';
    case 8:
      return 'col-span-8';
    case 9:
      return 'col-span-9';
    case 10:
      return 'col-span-10';
    case 11:
      return 'col-span-11';
    case 12:
      return 'col-span-12';
    case 'auto':
      return 'col-auto';
    default:
      return '';
  }
}
function getColSpanStringS(xs: GridItemType): string {
  switch (xs) {
    case 1:
      return 's:col-span-1';
    case 2:
      return 's:col-span-2';
    case 3:
      return 's:col-span-3';
    case 4:
      return 's:col-span-4';
    case 5:
      return 's:col-span-5';
    case 6:
      return 's:col-span-6';
    case 7:
      return 's:col-span-7';
    case 8:
      return 's:col-span-8';
    case 9:
      return 's:col-span-9';
    case 10:
      return 's:col-span-10';
    case 11:
      return 's:col-span-11';
    case 12:
      return 's:col-span-12';
    case 'auto':
      return 's:col-auto';
    default:
      return '';
  }
}
function getColSpanStringM(xs: GridItemType): string {
  switch (xs) {
    case 1:
      return 'm:col-span-1';
    case 2:
      return 'm:col-span-2';
    case 3:
      return 'm:col-span-3';
    case 4:
      return 'm:col-span-4';
    case 5:
      return 'm:col-span-5';
    case 6:
      return 'm:col-span-6';
    case 7:
      return 'm:col-span-7';
    case 8:
      return 'm:col-span-8';
    case 9:
      return 'm:col-span-9';
    case 10:
      return 'm:col-span-10';
    case 11:
      return 'm:col-span-11';
    case 12:
      return 'm:col-span-12';
    case 'auto':
      return 'm:col-auto';
    default:
      return '';
  }
}
function getColSpanStringMl(xs: GridItemType): string {
  switch (xs) {
    case 1:
      return 'ml:col-span-1';
    case 2:
      return 'ml:col-span-2';
    case 3:
      return 'ml:col-span-3';
    case 4:
      return 'ml:col-span-4';
    case 5:
      return 'ml:col-span-5';
    case 6:
      return 'ml:col-span-6';
    case 7:
      return 'ml:col-span-7';
    case 8:
      return 'ml:col-span-8';
    case 9:
      return 'ml:col-span-9';
    case 10:
      return 'ml:col-span-10';
    case 11:
      return 'ml:col-span-11';
    case 12:
      return 'ml:col-span-12';
    case 'auto':
      return 'ml:col-auto';
    default:
      return '';
  }
}
function getColSpanStringL(xs: GridItemType): string {
  switch (xs) {
    case 1:
      return 'l:col-span-1';
    case 2:
      return 'l:col-span-2';
    case 3:
      return 'l:col-span-3';
    case 4:
      return 'l:col-span-4';
    case 5:
      return 'l:col-span-5';
    case 6:
      return 'l:col-span-6';
    case 7:
      return 'l:col-span-7';
    case 8:
      return 'l:col-span-8';
    case 9:
      return 'l:col-span-9';
    case 10:
      return 'l:col-span-10';
    case 11:
      return 'l:col-span-11';
    case 12:
      return 'l:col-span-12';
    case 'auto':
      return 'l:col-auto';
    default:
      return '';
  }
}
function getColSpanStringXl(xs: GridItemType): string {
  switch (xs) {
    case 1:
      return 'xl:col-span-1';
    case 2:
      return 'xl:col-span-2';
    case 3:
      return 'xl:col-span-3';
    case 4:
      return 'xl:col-span-4';
    case 5:
      return 'xl:col-span-5';
    case 6:
      return 'xl:col-span-6';
    case 7:
      return 'xl:col-span-7';
    case 8:
      return 'xl:col-span-8';
    case 9:
      return 'xl:col-span-9';
    case 10:
      return 'xl:col-span-10';
    case 11:
      return 'xl:col-span-11';
    case 12:
      return 'xl:col-span-12';
    case 'auto':
      return 'xl:col-auto';
    default:
      return '';
  }
}
const GridItem: React.FC<GridItemProps> = ({
  className,
  children,
  ...props
}) => {
  const {
    xs = null,
    s = null,
    m = null,
    ml = null,
    l = null,
    xl = null,
    colStartXs = null,
    colEndXs = null,
    colStartS = null,
    colEndS = null,
    colStartM = null,
    colEndM = null,
    colStartMl = null,
    colEndMl = null,
    colStartL = null,
    colEndL = null,
    colStartXl = null,
    colEndXl = null,
  } = props;

  const xsString = getColSpanString(xs);
  const sString = getColSpanStringS(s);
  const mString = getColSpanStringM(m);
  const mlString = getColSpanStringMl(ml);
  const lString = getColSpanStringL(l);
  const xlString = getColSpanStringXl(xl);

  const colStartStringXs = colStartXs ? getColStartString(colStartXs) : '';
  const colStartStringS = colStartS ? getColStartStringS(colStartS) : '';
  const colStartStringM = colStartM ? getColStartStringM(colStartM) : '';
  const colStartStringMl = colStartMl ? getColStartStringMl(colStartMl) : '';
  const colStartStringL = colStartL ? getColStartStringL(colStartL) : '';
  const colStartStringXl = colStartXl ? getColStartStringXl(colStartXl) : '';

  const colEndStringXs = colEndXs ? getColEndString(colEndXs) : '';
  const colEndStringS = colEndS ? getColEndStringS(colEndS) : '';
  const colEndStringM = colEndM ? getColEndStringM(colEndM) : '';
  const colEndStringMl = colEndMl ? getColEndStringMl(colEndMl) : '';
  const colEndStringL = colEndL ? getColEndStringL(colEndL) : '';
  const colEndStringXl = colEndXl ? getColEndStringXl(colEndXl) : '';

  const classString = [
    xsString,
    sString,
    mString,
    mlString,
    lString,
    xlString,
    colStartStringXs,
    colEndStringXs,
    colStartStringS,
    colEndStringS,
    colStartStringM,
    colEndStringM,
    colStartStringMl,
    colEndStringMl,
    colStartStringL,
    colEndStringL,
    colStartStringXl,
    colEndStringXl,
    className,
  ]
    .filter((c) => c !== '')
    .join(' ');

  return <div className={classString}>{children}</div>;
};

export default GridItem;
